<template>
  <rest-page :fetch-endpoint="fetchEndpoint" :key="key">
    <page-content style="position: relative">
      <div
        class="link-details"
        :style="linkDetailsStyles"
        v-if="linkDetailsData"
      >
        <p>
          {{ $t('CampaignChannelAnalytics_ClickMap_Unique_Clicks') }}:
          {{ linkDetailsData[1].value }}
        </p>
        <b>
          {{
            Math.floor(
              (linkDetailsData[1].value / linkDetailsData[0].value) * 100
            )
          }}%
        </b>
      </div>
      <el-row>
        <el-col :span="6" style="height: 1px" id="leftColumn"></el-col>
        <el-col :span="12">
          <div class="template-wrapper">
            <el-card>
              <iframe
                sandbox="allow-same-origin"
                v-if="selectedVariant"
                id="iframe"
              ></iframe>
            </el-card>
          </div>
        </el-col>
        <el-col :span="6">
          <enum-select
            class="variants-select"
            v-if="variants.hasOwnProperty(1)"
            :options="variants"
            v-model="selectedVariantIndex"
            title
            :placeholder="
              $t('CampaignChannelAnalytics_ClickMap_Variant_Placeholder')
            "
          />
        </el-col>
      </el-row>
    </page-content>
  </rest-page>
</template>

<script>
import PageContent from '@/common/components/page/PageContent'
import EnumSelect from '@/common/components/form/EnumSelect'
import RestPage from '@/common/components/rest/RestPage'
import { projectEndpoint } from '@/core/helpers'
import { EventBus } from '@/core/EventBus'
import moment from 'moment'
export default {
  name: 'ClickMap',
  components: { RestPage, EnumSelect, PageContent },
  data() {
    return {
      variants: {},
      selectedVariantIndex: null,
      items: [],
      linkDetailsPosition: {},
      linkDetailsData: null,
      date_from: this.$route.query.date_from || '',
      date_to: this.$route.query.date_to || '',
      key: '',
      zeroMetrics: [
        { name: 'amount_total', value: 1 },
        { name: 'amount_unique', value: 0 }
      ]
    }
  },
  mounted() {
    EventBus.$on('common/components/dashboard/DateFilter:onChange', event => {
      this.date_from = moment(event.start).format('YYYY-MM-DD')
      this.date_to = moment(event.end).format('YYYY-MM-DD')
      this.key = new Date().getTime() // refresh the table items
    })
  },
  methods: {
    getMetricsByUrl(url) {
      let metrics = this.zeroMetrics
      this.selectedVariant.links.forEach(val => {
        if (val.fields.url.replace(/\/$/, '') === url.replace(/\/$/, '')) {
          metrics = Object.assign({}, val.metrics)
        }
      })
      return metrics
    },
    initMetrics() {
      const self = this
      const iframe = $('#iframe')
      iframe.contents().find('head').append(`
            <style> .dot {
                height: 20px;
                width: 20px;
                background-color: #c81d8745;
                border-radius: 50%;
               display: inline-block;
                position: absolute;
                margin-left: 4px;
              }
              .dot span {
                height: 10px;
                width: 10px;
                background-color: #c81d87;
                border-radius: 50%;
                position: absolute;
                margin-left: 4px;
                top: 5px;
                left: 1px;
              }
              </style>`)
      iframe
        .contents()
        .find('a')
        .each(function(key, val) {
          $(val)
            .append(`<div class="dot" ><span></span></div>`)
            .children('.dot')
            .hover(
              function() {
                let position = $(this).position()

                self.linkDetailsPosition = {
                  left: `${position.left + $('#leftColumn').width() + 55}px`,
                  top: `${position.top + 43}px`
                }
                self.linkDetailsData = self.getMetricsByUrl($(val).attr('href'))
              },
              function() {
                self.linkDetailsData = null
              }
            )
            .click(function(e) {
              e.preventDefault()
            })
        })
      iframe.height(
        iframe
          .contents()
          .find('html')
          .height() + 20
      )
    }
  },
  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `campaigns/${this.$route.query.id}/analytics/${this.$route.query.channel}/clickmap`,
        params: {
          date_from: this.date_from,
          date_to: this.date_to
        },
        handler: data => {
          this.items = data.stats
          data.stats.forEach((val, key) => {
            let language = ''
            if (val.language) {
              const languageNames = new Intl.DisplayNames(['en'], {
                type: 'language'
              })
              language = languageNames.of(val.language)
            }

            let variant = ''
            if (data.ab) {
              variant =
                this.$t('CampaignChannelAnalytics_ClickMap_Variant') +
                ' ' +
                val.variant
            }
            this.variants[key] =
              variant + (variant && language ? ' - ' : '') + language
          })
          if (this.variants.hasOwnProperty('0')) {
            this.selectedVariantIndex = '0'
          }
        }
      })
    },
    selectedVariant() {
      if (this.selectedVariantIndex) {
        return this.items[this.selectedVariantIndex]
      }
      return null
    },
    linkDetailsStyles() {
      return {
        ...this.linkDetailsPosition
      }
    }
  },
  watch: {
    selectedVariant() {
      setTimeout(() => {
        $('#iframe').load(() => {
          this.initMetrics()
          $('#iframe').unbind('load')
        })
        let iframe = document.getElementById('iframe')
        if (iframe && this.selectedVariant) {
          iframe.srcdoc = this.selectedVariant.markup
        }
      }, 50)
    }
  }
}
</script>

<style scoped>
.page-content {
  background-color: #f5f7fa !important;
}
.variants-select {
  width: 100%;
}
#iframe {
  border: none;
  width: 100%;
}
.template-wrapper {
  font-size: 14px;
  line-height: 22px;
}
>>> .link-details {
  font-size: 14px;
  line-height: 22px;
  display: inline-block;
  height: 52px;
  padding: 10px;
  background-color: white;
  border: 1px solid #e4e4e4;
  position: absolute;
  margin-left: 40px;
  z-index: 9;
  border-radius: 4px;
  -webkit-box-shadow: 0px 1px 8px 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 1px 8px 1px rgba(0, 0, 0, 0.1);
  width: 120px;
}

>>> .link-details:before {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 5px solid white;
  top: 5px;
  left: -5px;
}
</style>



// WEBPACK FOOTER //
// src/modules/analytics/components/ClickMap.vue